import { Button } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

export function FooterTable({
  text,
  functionLeftButton,
  functionRightButton,
  buttonBackDisabled,
  buttonNextDisabled,
  offset,
  rowsPerPage,
  quantityRows,
  functionOnChange,
  setOffset,
}) {
  const textPagination = () => {
    if (text) return text;
    const inicialIndexDefault = 1;
    if (offset) {
      return `${offset + 1}–${
        offset + rowsPerPage < quantityRows
          ? offset + rowsPerPage
          : quantityRows
      } of ${quantityRows}`;
    } else {
      return `${inicialIndexDefault}–${
        rowsPerPage < quantityRows ? rowsPerPage : quantityRows
      } of ${quantityRows}`;
    }
  };

  const buttonFunction = (button) => {
    const newOffset =
      button === "back" ? offset - rowsPerPage : offset + rowsPerPage;
    setOffset(newOffset);
    functionOnChange(newOffset);
  };

  const leftButton = (direction) => {
    if (functionLeftButton) return functionLeftButton(direction);
    buttonFunction("back");
  };

  const rightButton = (direction) => {
    if (functionRightButton) return functionRightButton(direction);
    buttonFunction("next");
  };
  const backDisabled = (direction) => {
    if (buttonBackDisabled) return buttonBackDisabled;
    const initialOffset = 0;
    if (offset === initialOffset) return true;

    return false;
  };

  const nextDisabled = () => {
    if (buttonNextDisabled) return buttonNextDisabled;

    if (offset + rowsPerPage >= quantityRows) return true;

    return false;
  };
  return (
    <div
      className="flex justify-end items-center h-[52px]"
      style={{ borderTop: "1px solid #e5e7eb" }}
    >
      <p className="mr-10">{textPagination()} </p>
      <Button
        onClick={() => leftButton()}
        disabled={backDisabled()}
        className="px-3"
      >
        <LeftOutlined style={{ color: "#6b7280" }} />
      </Button>
      <Button
        onClick={() => rightButton()}
        disabled={nextDisabled()}
        className="px-3"
      >
        <RightOutlined style={{ color: "#6b7280" }} />
      </Button>
    </div>
  );
}
